export const SOFR_HORIZON_TOOLTIP = "CME-sourced 1-Month Term SOFR forward projections populate up to 24 months from today's date. " + 
                                    "Beyond that window, the curve holds flat at the last projected rate. You can override any period.";

const STICKY_COLUMN_COUNT = 5;

export const renderSpacerCells = () => Array.from({ length: STICKY_COLUMN_COUNT }, (_, index) => (
    <td key={`sofr-spacer-${index}`} className="NSTable__tbody__tr__td" />
));
